export default {
  view: "Gardens",
  gardens: [],
  // index.js open weather api creates a weather object here.
};
